
// const BASE_URL =  "https://api.twelvevest.com/api/v1/";
// const BASE_URL = 'http://127.0.0.1:8000/api/v1/';
const BASE_URL =  "https://apisandbox.twelvevest.com/api/v1/";

// const BASE_URL = 'http://67.207.81.131:5000/api/v1/'

export {BASE_URL}
